import { useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';

import NoticeBoard from '../notice/NoticeBoard';

import Slider from './sections/slider/Slider';
import HomeDescription from './sections/description/HomeDescription';
import AWMCommunityInfo from './sections/stats/AWMCommunityInfo';
import CommunitySpirit from './sections/spirit/CommunitySpirit';
import Greenary from './sections/greenary/Greenary';

import './HomePage.css';

const HomePage = () => {
  const [showNoticeBoard, setShowNoticeBoard] = useState(true);

  return (
    <div className="home-container">
      <section className="home-slider-section">
        <Slider />
      </section>

      <section className="home-content-section">
        <AWMCommunityInfo />
      </section>

      <section className="home-main-content-section">
        <Container>
          <Row>
            {showNoticeBoard && (
              <Col lg={4} className="order-1 order-lg-2">
                <aside className="home-notice-section">
                  <NoticeBoard onDisplayChange={setShowNoticeBoard} />
                </aside>
              </Col>
            )}

            <Col lg={showNoticeBoard ? 8 : 12} className="order-2 order-lg-1">
              <div className="home-description-wrapper">
                <HomeDescription />
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="home-community-spirit-section">
        <CommunitySpirit />
      </section>

      <section className="home-greenary-section">
        <Greenary />
      </section>
    </div>
  );
};

export default HomePage;
